import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useDeleteDebounce } from '../../../../utils/useDeleteDebounce'
import { useArchiveMultipleBuffetDishMutation } from '../../../../core/api/BuffetDishApi'
import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface UseDeleteDishResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeleteDish = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeleteDishResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultipleBuffetDish] = useArchiveMultipleBuffetDishMutation()
  const { t } = useTranslation()

  const deleteDish = () => {
    if (!!chooseItems) {
      archiveMultipleBuffetDish({
        dishes: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные блюда успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteDish,
    extraText: t(
      'Выбранные вами блюда будут удалены на сервере и на всех станциях!',
    ),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler:
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
        ? openDeletePopup
        : onDeleteHandler,
    onDeleteHandler,
    closeDeletePopup,
  }
}
